// src/utils/menuUtils.js
export function getAllowedManageTeamTabs(menuName) {
    const menuTabStructure = JSON.parse(localStorage.getItem("menuTabStructure") || "{}");
    // Adjust the key as per your menu structure
    // const manageTeamMenu = menuTabStructure["manageTeam"];
    // if (!manageTeamMenu || !manageTeamMenu.tabs) return [];
    // return Object.values(manageTeamMenu.tabs).map(tab => tab.displayName);
    const manageMenu = menuTabStructure[menuName];
    if (!manageMenu || !manageMenu.tabs) return [];
    return Object.values(manageMenu.tabs).map(tab => tab.displayName);
}